import React from 'react';
import "./FooterDesktop.css";
import { useTranslation } from 'react-i18next';

const FooterDesktop = () => {
  const { t } = useTranslation();

  return (
    <div className="footer-container">
      <div className="footer-row1">
        <div className="footer-row1-left">
          <div className="footer-row1-left-cols">
            <div className="footer-titles">{t("contact-us")}</div>

            <div className="footer-texts-container">
              <div className="footer-texts">{t("phone-number")}</div>
              <div className="footer-texts">{t("email")}</div>
              <div className="footer-texts">{t("address")}</div>
            </div>
          </div>

          <div className="footer-row1-left-cols">
            <div className="footer-titles">{t("help")}</div>

            <div className="footer-texts-container">
              <div className="footer-texts click">
                {t("help-center")}
              </div>

              <div className="footer-texts click">
                {t("reviews")}
              </div>
            </div>
          </div>

          <div className="footer-row1-left-cols faqs">
            {t("faqs")}
          </div>
        </div>

        <div className="footer-row1-right">
          <div className="footer-socials">
            <div className="icon-socials-container">
              <a
                href="https://www.citeve.pt/"
                target="_blank"
                rel="noreferrer"
                aria-label="CITEVE"
              >
                <img
                  src="/images/logo_CITEVE_dpp.png"
                  alt=""
                  className="icon-socials"
                />
              </a>
            </div>
          </div>

          <div className="footer-sponsors-container">
            <img
              src="/images/prr_rp.png"
              alt="icon-sponsors-v2"
              className="icon-sponsors-v2"
            />

            <img
              src="/images/barra-financiamento-beat-barra-v2.png"
              alt="icon-sponsors-v2"
              className="icon-sponsors-v2"
            />
          </div>
        </div>
      </div>

      <div className="footer-row2">
        <div className="footer-row2-texts">
          {t("copyright-2024-all-rights-reserved")}
        </div>

        <div className="terms-privacy-container">
          <div className="footer-row2-texts click">
            {t("terms-of-use")}
          </div>

          <div className="footer-row2-texts click">
            {t("privacy-policy")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterDesktop;